import { ApiKy } from './index'
import { GetVersionResponse } from '~/types/version'

export default class Api extends ApiKy {
  getVersion() {
    return this.ky.get(`${this.url}`)?.json<GetVersionResponse>()
  }
}
